!(function () {
  'use strict';
  const CartBar = window.customElements.get('cart-bar');
  if (!CartBar) return;
  class CustomCartBar extends CartBar {
    toggleCartBarOnScroll() {
      if (this.formWrapper) {
        const stickyHeaderHeight = window.theme?.readHeights()?.stickyHeaderHeight;
        const rect = this.formWrapper.getBoundingClientRect();
        this.classList.toggle('is-visible', rect.top < stickyHeaderHeight - rect.height);
      }
    }
  }
  customElements.get('custom-cart-bar') || customElements.define('custom-cart-bar', CustomCartBar);
})();
